import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskDetailsComponent } from './task-details.component';
import { MatCardModule } from '@angular/material/card';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatIconModule } from '@angular/material/icon';
import { FiRollupContentModule } from '@fi-shared/rollup/rollup-content.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { FiCommentsListModule } from '@fi-shared/fi-comments/fi-comments-list/fi-comments-list.module';
import { FiObjectsSelectorComponentModule } from '@fi-shared/objects-selector';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { MatChipsModule } from '@angular/material/chips';
import { FormsModule } from '@angular/forms';
import { FiTaskV2SharedComponentsModule } from '@fi-app/task-v2/components/fi-task-v2-shared-components.module';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        FiAppTextSharedModule,
        FiRollupContentModule,
        FiCommentsListModule,
        FiObjectsSelectorComponentModule,
        FiAttachmentsModule,
        MatCheckboxModule,
        InfoIconModule,
        FiProfileIconModule,
        SelectSearchModule,
        FiBindHtmlCompileModule,
        MatChipsModule,
        FormsModule,
        FiTaskV2SharedComponentsModule,
    ],
    declarations: [TaskDetailsComponent],
    exports: [TaskDetailsComponent],
})
export class TaskDetailsModule {}
